/*
 app dependencies
 - var body

 lib dependencies
*/

const scMobileMenu = (function($)
{
    const   _showTriggers = document.querySelectorAll('.js-show-mobile-menu'),
            _hideTriggers = document.querySelectorAll('.js-hide-mobile-menu'),
            _searchField = document.querySelector('.js-mobile-search-input'),
            _contentCover = document.querySelector('.js-content-cover'),
            _bodyToggleClass = 'show-mobile-menu';

	//module functions
	function init()
	{
		for (const trigger of _showTriggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                showMobileMenu();
            });
        }

        for (const trigger of _hideTriggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                hideMobileMenu();
            });
        }

        _contentCover.addEventListener('click', function(e)
        {
            hideMobileMenu();
        });
	}

    function showMobileMenu(focusSearch = false)
    {
        body.classList.add(_bodyToggleClass);
        if (focusSearch)
        {
            _searchField.focus();
        }
    }
    function hideMobileMenu()
    {
        body.classList.remove(_bodyToggleClass);
    }

	//reveal public vars and functions
	return {
		//vars

		//functions
		init,
        showMobileMenu
	};

})(jQuery);
